import {
	GetPlayerPlaylogRequest,
	GetPlayerPlaylogResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerPlaylog } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerPlaylog(
	playerId: string,
	payload: GetPlayerPlaylogRequest,
	props?: UseBaseQueryOptions<GetPlayerPlaylogResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerPlaylog, playerId, payload],
		queryFn: () => getPlayerPlaylog(playerId, payload),
		...props,
	})
}
